import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { forwardRef } from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';
import { match, Pattern } from 'ts-pattern';
import CheckboxSquareIcon from '@/assets/icon/ic_checkbox_square.svg';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color';
import SignupBoxInput from '@/screens/SignupScreen/components/SignupBoxInput';
const TOP_DOMAINS = ['naver.com', 'gmail.com', 'hanmail.net'];
const DOMAIN_PREFIX_MAP = {
    n: ['naver.com', 'nate.com'],
    g: ['gmail.com'],
    h: ['hanmail.net'],
    k: ['kakao.com'],
    d: ['daum.net'],
};
function getDomainSuggestions(email) {
    var _a;
    const atIndex = email.indexOf('@');
    if (atIndex === -1) {
        return [];
    }
    const domainPart = email.slice(atIndex + 1);
    if (domainPart === '') {
        return TOP_DOMAINS;
    }
    const lowerDomain = domainPart.toLowerCase();
    const firstChar = lowerDomain[0];
    const candidates = (_a = DOMAIN_PREFIX_MAP[firstChar]) !== null && _a !== void 0 ? _a : [];
    // 이미 완전히 일치하는 도메인은 추천할 필요 없으므로 제외.
    return candidates.filter(domain => domain.startsWith(lowerDomain) && domain !== lowerDomain);
}
const UserEmailForm = forwardRef(({ value, state, onChangeText, onChangeNewsLetterSubscriptionAgreed, onSubmitEditing, isClearable = false, }, ref) => {
    // focus 여부와 무관하게 입력된 텍스트 기준으로 추천 도메인을 표시한다.
    const suggestions = getDomainSuggestions(value.email);
    const handleSelectDomain = (domain) => {
        const atIndex = value.email.indexOf('@');
        const localPart = atIndex !== -1 ? value.email.slice(0, atIndex) : value.email;
        onChangeText(`${localPart}@${domain}`);
    };
    return (_jsxs(View, { style: { paddingHorizontal: 20 }, children: [_jsx(SignupBoxInput, { ref: ref, label: "\uC774\uBA54\uC77C", isRequired: true, placeholder: "\uC774\uBA54\uC77C\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694", returnKeyType: "next", state: state.email, caption: suggestions.length > 0
                    ? undefined
                    : match(state.email)
                        .with({ errorMessage: Pattern.string }, error => error.errorMessage)
                        .otherwise(() => undefined), value: value.email, onChangeText: onChangeText, onSubmitEditing: onSubmitEditing, isClearable: isClearable }), suggestions.length > 0 && (_jsx(ChipRow, { children: suggestions.map(domain => (_jsx(DomainChip, { elementName: "email_domain_suggestion", onPress: () => handleSelectDomain(domain), children: _jsx(DomainChipText, { children: domain }) }, domain))) })), _jsxs(LetterBox, { elementName: "newsletter_subscription_checkbox", activeOpacity: 0.8, onPress: () => onChangeNewsLetterSubscriptionAgreed(!value.isNewsLetterSubscriptionAgreed), children: [_jsx(CheckboxSquareIcon, { color: value.isNewsLetterSubscriptionAgreed
                            ? color.brandColor
                            : color.gray25, width: 24, height: 24 }), _jsx(LetterText, { children: "\uACC4\uB2E8\uBFCC\uC154\uD074\uB7FD\uC758 \uB274\uC2A4\uB808\uD130\uB97C \uBC1B\uC544\uBCF4\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?" })] })] }));
});
UserEmailForm.displayName = 'UserEmailForm';
const ChipRow = styled.View `
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: 12px;
`;
const DomainChip = styled(SccTouchableOpacity) `
  padding-vertical: 8px;
  padding-horizontal: 14px;
  border-radius: 18px;
  border-width: 1px;
  border-color: ${color.gray20};
  background-color: ${color.white};
`;
const DomainChipText = styled.Text `
  font-size: 14px;
  color: ${color.gray100};
`;
const LetterBox = styled(SccTouchableOpacity) `
  flex-direction: row;
  align-items: center;
  gap: 4px;
  margin-top: 12px;
`;
const LetterText = styled.Text `
  font-size: 14px;
  color: ${color.gray100};
`;
export default UserEmailForm;
